export type HubPwaBranding = {
  personalizado: boolean
  name: string
  short_name: string
  icon_180: string
  icon_192: string
  icon_512: string
  manifest_url: string
  theme_color: string
}

function ensureMeta(name: string, content: string): void {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.content = content
}

function ensureLink(rel: string, href: string, sizes?: string): void {
  const selector = sizes
    ? `link[rel="${rel}"][sizes="${sizes}"]`
    : `link[rel="${rel}"]`
  let el = document.querySelector(selector) as HTMLLinkElement | null
  if (!el) {
    el = document.createElement('link')
    el.rel = rel
    if (sizes) el.sizes = sizes
    document.head.appendChild(el)
  }
  el.href = href
}

/** Atualiza title / Apple meta / manifest para a marca da campanha (ou default). */
export function applyHubPwaBranding(pwa: HubPwaBranding | undefined | null): void {
  if (typeof document === 'undefined' || !pwa) return

  if (pwa.personalizado) {
    const appTitle = pwa.short_name || pwa.name
    document.title = pwa.name || appTitle
    ensureMeta('apple-mobile-web-app-title', appTitle)
    ensureMeta('theme-color', pwa.theme_color || '#009b3a')
    ensureLink('apple-touch-icon', pwa.icon_180 || pwa.icon_192, '180x180')
    ensureLink('apple-touch-icon', pwa.icon_192, '192x192')
  }

  const manifestHref = pwa.manifest_url || '/public/manifest.php'
  let manifest = document.querySelector('link[rel="manifest"]') as HTMLLinkElement | null
  if (!manifest) {
    manifest = document.createElement('link')
    manifest.rel = 'manifest'
    manifest.crossOrigin = 'use-credentials'
    document.head.appendChild(manifest)
  }
  manifest.crossOrigin = 'use-credentials'
  manifest.href = manifestHref
}
